export function filterProcedureCodes(codes: string[]) {
  const allProcedureCodes = [] as string[];
  const invalidProcedureCodes = [] as string[];

  codes.forEach((code) => {
    if (allProcedureCodes.includes(code)) {
      invalidProcedureCodes.push(code);
    } else {
      allProcedureCodes.push(code);
    }
  });

  return allProcedureCodes.filter((code) => !invalidProcedureCodes.includes(code));
}
